var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5816 15.537C10.7517 15.3654 10.7504 15.0884 10.5788 14.9183C10.4072 14.7482 10.1302 14.7494 9.9601 14.921L8.94083 15.9494C8.52717 16.3668 8.24248 16.6531 8.00126 16.8468C7.76693 17.035 7.61642 17.0996 7.48163 17.1167C7.39699 17.1275 7.31135 17.1275 7.22671 17.1167C7.09191 17.0996 6.9414 17.035 6.70708 16.8468C6.46585 16.6531 6.18116 16.3668 5.7675 15.9494L4.74824 14.921C4.57815 14.7494 4.30114 14.7482 4.12952 14.9183C3.95791 15.0884 3.95667 15.3654 4.12676 15.537L5.16439 16.5839C5.55519 16.9782 5.87459 17.3005 6.15918 17.5291C6.45512 17.7667 6.75551 17.9388 7.11607 17.9847C7.27417 18.0049 7.43416 18.0049 7.59226 17.9847C7.95283 17.9388 8.25321 17.7667 8.54915 17.5291C8.83374 17.3005 9.15314 16.9782 9.54394 16.5839L10.5816 15.537Z",
    fill: "#2F3259"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12937 5.46278C3.95928 5.63439 3.96051 5.9114 4.13213 6.08149C4.30374 6.25158 4.58075 6.25034 4.75084 6.07873L5.7701 5.05033C6.18377 4.63296 6.46846 4.34666 6.70968 4.15293C6.944 3.96475 7.09451 3.90019 7.22931 3.88301C7.31395 3.87222 7.39959 3.87222 7.48423 3.88301C7.61903 3.90019 7.76954 3.96475 8.00386 4.15293C8.24508 4.34666 8.52977 4.63296 8.94344 5.05033L9.9627 6.07873C10.1328 6.25034 10.4098 6.25158 10.5814 6.08149C10.753 5.9114 10.7543 5.63439 10.5842 5.46278L9.54655 4.41585C9.15575 4.02153 8.83634 3.69925 8.55175 3.4707C8.25581 3.23303 7.95543 3.06099 7.59487 3.01503C7.43677 2.99488 7.27677 2.99488 7.11868 3.01503C6.75811 3.06099 6.45773 3.23303 6.16179 3.4707C5.8772 3.69925 5.5578 4.02153 5.167 4.41585L4.12937 5.46278Z",
    fill: "#2F3259"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 0.5,
    transform: "rotate(180 11.5 10.5)",
    fill: "#2F3259"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 0.5,
    transform: "rotate(180 9.5 10.5)",
    fill: "#2F3259"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 0.5,
    transform: "rotate(180 7.5 10.5)",
    fill: "#2F3259"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 0.5,
    transform: "rotate(180 5.5 10.5)",
    fill: "#2F3259"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 10.5,
    r: 0.5,
    transform: "rotate(180 3.5 10.5)",
    fill: "#2F3259"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoth);
export default __webpack_public_path__ + "static/media/both.ea244f56648002b035b491d654b11640.svg";
export { ForwardRef as ReactComponent };